import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Container } from 'react-bootstrap';
import { IdTokenData } from './../../components/user/id-token';
import { AccessTokenData } from './../../components/user/access-token';
import { SetupInstance } from '../../app/msal-account-helpers';
import { arrayAny } from '../../utils/arrayUtils';

/***
 * Component to detail ID token claims with a description for each claim. For more details on ID token claims, please check the following links:
 * ID token Claims: https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token
 * Optional Claims:  https://docs.microsoft.com/en-us/azure/active-directory/develop/active-directory-optional-claims#v10-and-v20-optional-claims-set
 */
export const UserDebug = () => {

    let { instance } = useMsal();
    
    instance = SetupInstance(instance);

    const activeAccount = instance.getActiveAccount();

    return (
        <>

            <AuthenticatedTemplate>
                {activeAccount && activeAccount.idTokenClaims && arrayAny(Object.entries(activeAccount.idTokenClaims)) ? (
                    <Container>
                        <IdTokenData idTokenClaims={activeAccount.idTokenClaims} />
                        <AccessTokenData />
                    </Container>
                ) : <>Loading...</>}
            </AuthenticatedTemplate>
        </>
    );
};